import QuestionnairesPageView from "./QuestionnairesPageView";

function QuestionnairesPage() {
  return <QuestionnairesPageView />;
}

export default QuestionnairesPage;
